// PDO 사진 캡션 — 파일명(picture_key)에서 "염색_계대_배율 (번호)" 를 뽑는다.  예) H&E_P17_200X (2)
//   쓰는 곳: 오가노이드 정보 사진 아래(ImageComponent) · 편집 창 목록(ImageManagementModal) · 업로드 미리보기(PictureAutoUpload)
//   세 곳이 각자 복사본을 갖고 있다가 어긋났다. 여기 하나만 고친다.
//
//   사람이 붙인 이름이라 같은 사진 번호도 모양이 제각각이다 — 위치·띄어쓰기에 상관없이 읽는다.
//     …_200X(2)_D162 · …_200X (2)_D162 · …_200X_D162 (2) · …_100X(2).jpg
//   윈도우 복사본(" - 복사본", " - Copy", 예전 업로드에서 깨진 " - ë³µì¬ë³¸")은 "(사본)" 으로 표시한다.

const STAIN_HE = /^(H&E|HE|H&3)$/;
const STAIN_IHC = /^(MLH1|MSH2|MSH6|PMS2|P53|HER2|ARID1A|EBV|CD8|CD3|CD4|CK7|CK20|KI67|KI-67|PDL1|PD-L1|TTF1|CDX2|GATA3|SOX10)$/;
// 깨진 표기는 'ë³µì' + 제어문자 + '¬ë³¸' 이라 사이를 느슨하게 본다
const COPY_MARK = /\s*-\s*(복사본|copy|ë³µì[\s\S]{0,3}ë³¸)\s*$/i;

/**
 * @returns {{ stain, passage, mag, copyNo, isCopy, text }}
 *   text 는 화면에 쓸 문자열. 하나도 못 읽으면 원래 이름.
 */
export function parsePictureCaption(name) {
    const out = { stain: null, passage: null, mag: null, copyNo: null, isCopy: false, text: name || '' };
    if (!name) return out;

    let s = String(name).trim().replace(/\.(jpe?g|png|tiff?|bmp)$/i, '').replace(/[.\s]+$/, '');
    if (COPY_MARK.test(s)) { out.isCopy = true; s = s.replace(COPY_MARK, ''); }

    // 같은 조건 사진 번호 — (2) · ( 2 ) 등, 이름 어디에 있어도
    const num = s.match(/\(\s*(\d{1,3})\s*\)/);
    if (num) out.copyNo = Number(num[1]);
    s = s.replace(/\(\s*\d{1,3}\s*\)/g, ' ');

    const parts = s.toUpperCase().split(/[\s,=+_()[\]]+/).filter(Boolean);
    for (const p of parts) {
        if (!out.stain) {
            if (p === 'BF') out.stain = 'BF';
            else if (STAIN_HE.test(p) || p.startsWith('H&E')) out.stain = 'H&E';
            else if (STAIN_IHC.test(p)) out.stain = p === 'KI-67' ? 'KI67' : p;
        }
        if (!out.passage && /^P\d+(-\d+)?$/.test(p)) out.passage = p;
        if (!out.mag) {
            const m = p.match(/^(\d{1,4})X$/) || p.match(/^X(\d{1,4})$/);
            if (m && Number(m[1]) > 0) out.mag = m[1] + 'X';
        }
    }

    // 배율을 못 찾았으면 흔한 오기를 한 번 더 본다
    //   NCM100X · 100XD32 (다른 조각에 붙음) → 100X
    //   _200_ · _100 (X 빠짐) → 200X — 100·200·400·1000 만 (01·40 같은 번호·일수와 헷갈리지 않게)
    if (!out.mag) {
        for (const p of parts) {
            const m = p.match(/^[A-Z+-]*?(\d{2,4})X(?:D\d+)?$/);
            if (m && Number(m[1]) > 0) { out.mag = m[1] + 'X'; break; }
        }
    }
    if (!out.mag) {
        const bare = parts.find((p) => /^(100|200|400|1000)$/.test(p));
        if (bare) out.mag = bare + 'X';
    }

    const core = [out.stain, out.passage, out.mag].filter(Boolean).join('_');
    if (core) {
        out.text = core + (out.copyNo ? ` (${out.copyNo})` : '') + (out.isCopy ? ' (사본)' : '');
    }
    return out;
}

export function pictureCaption(name) {
    return parsePictureCaption(name).text;
}
